import React, { memo } from 'react';
import StoreCard from './StoreCard';
import StoreMarkerIcon from './storeMarkerIcon.svg';

const StoreList = memo(function StoreList({ stores, selectedStore, onSelect, loading }) {
  if (loading)
    return (
      <div className='d-flex justify-content-center my-3'>
        <div className='spinner-border' role='status' aria-label='Loading stores...'></div>
      </div>
    );
  if (!stores.length)
    return (
      <div className='text-center font-weight-bold mt-3'>
        <StoreMarkerIcon />
        <p className='mb-0'>No Dillard&apos;s stores nearby.</p>
        <p className='mb-0'>Refine your search and try again.</p>
      </div>
    );
  return stores.map((store) => (
    <StoreCard
      key={store.externalId}
      store={store}
      selected={selectedStore && selectedStore.externalId === store.externalId}
      onSelect={onSelect}
    />
  ));
});

export default StoreList;
